import config from '../config';

/**
 * Get the Google Tag Manager script snippet with configuration information.
 * Note: In order to maintain the script syntax after use of `` all back slashes must be escaped.
 */
// eslint-disable-next-line import/prefer-default-export
export function getGoogleTagManagerConfig() {
  return `
    (function(w,d,s,l,i){w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;j.defer=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;

    j.addEventListener('load', function() {var e = new CustomEvent('gtm_loaded', { bubbles: true });
      d.dispatchEvent(e);
    });

    f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${config.googleTagManagerId}');
  `;
}
